module.exports = __webpack_public_path__ + "img/jppdimg_mo7.933abcec.png";